import Image from "next/image";
import add_to_cart_with_blue_background from "@/assets/images/logo/add_to_cart_with_blue_background..svg";
import { useEffect, useState } from "react";
import { BsFillCartCheckFill } from "react-icons/bs";

interface CartButtonProps {
  item: any;
  cart: any;
  paginatedEvents: any;
  handleRemoveFromCart: () => void;
  handleAddToCart: () => void;
}

const CartButton = ({
  item,
  cart,
  paginatedEvents,
  handleRemoveFromCart,
  handleAddToCart,
}: CartButtonProps) => {
  const [cartLength, setCartLength] = useState(0);

  useEffect(() => {
    const matchingItem = cart.find(
      (val: any) =>
        val.group_name === item.group_name &&
        val.sub_type === item["Sub Type"] &&
        val?.Category === item?.Category,
    );
    setCartLength(matchingItem?.inCart || 0);
  }, [cart, paginatedEvents, item.group_name, item["Sub Type"], item.Category]); // item.group_name and item["Sub Type"] are added to dependencies because they are used inside the effect to match the correct cart item.

  return (
    <div>
      {cartLength ? (
        <div
          onClick={handleRemoveFromCart}
          title="Remove from cart"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            height: "3rem",
            width: "3rem",
            flex: "0 0 3rem",
            backgroundColor: "#EEF0FF",
            border: "1.5px solid #3F41D1",
            color: "#3F41D1",
            cursor: "pointer",
            transition: "all 0.2s ease",
          }}
        >
          <BsFillCartCheckFill size={18} />
        </div>
      ) : (
        <span
          className="d-inline-flex"
          data-toggle="tooltip"
          title="Add Participants"
        >
          <div
            className="hover-container"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              height: "3rem",
              width: "3rem",
              flex: "0 0 3rem",
              border: "1.5px solid #3F41D1",
              backgroundColor: "white",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onClick={handleAddToCart}
          >
            <Image src={add_to_cart_with_blue_background} alt="Add to cart" />
          </div>
        </span>
      )}
    </div>
  );
};

export default CartButton;
